import * as environments from 'src/environments.json';
const env = environments.default[process.env.REACT_APP_ENVIRONMENT.trim()];

const USE_CASE_URL = 'payment-receipts';

const downloadPaymentReceiptPdfById = (id) => {
  const url = `${env.api.url}/${USE_CASE_URL}/${id}/download/pdf`;

  window.location = url;
};

export default downloadPaymentReceiptPdfById;
